// frontend/src/presentation/context/NetworkSyncProvider.tsx
//
// Provider Silnika Synchronizacji. Montowany DOKŁADNIE RAZ (App.tsx / główny
// layout) — to jedyne miejsce, które wywołuje `useNetworkSync`, więc powstaje
// jeden serwis `OfflineSyncService`, jeden nasłuch zdarzeń 'online' i jeden
// strażnik równoległych przebiegów `processQueue`.

import type { ReactNode } from 'react'

import { useNetworkSync } from '../hooks/useNetworkSync'
import { NetworkSyncContext } from './networkSync'

/** Obejmuje drzewo aplikacji współdzielonym stanem Silnika Synchronizacji. */
export function NetworkSyncProvider({ children }: { children: ReactNode }): ReactNode {
  const value = useNetworkSync()
  return <NetworkSyncContext.Provider value={value}>{children}</NetworkSyncContext.Provider>
}
